import { Button, Modal } from "@talladega/components";
import { dateTimeFormatter, formatTimeOnly } from "@talladega/helpers";
import { convert, LocalDateTime } from "@js-joda/core";
import { Trans, useTranslation } from "next-i18next";
import { useRouter } from "next/router";

type Props = {
  dropOffAppointmentAt: string;
  dropOffLocationName: string;
  onClose?: () => void;
  onCancel: () => void;
};

const CancelDropOffAppointmentModal = ({
  dropOffAppointmentAt,
  dropOffLocationName,
  onClose,
  onCancel,
}: Props) => {
  const { t } = useTranslation(["purchase", "common"]);
  const { locale } = useRouter();

  const handleOnSubmit = () => {
    onCancel();
  };

  const formattedAppointmentDate = dateTimeFormatter(
    convert(LocalDateTime.parse(dropOffAppointmentAt)).toDate(),
    locale || "en",
    "MMMM D, YYYY"
  );

  const formattedAppointmentTime = formatTimeOnly(
    convert(LocalDateTime.parse(dropOffAppointmentAt)).toDate(),
    `${locale === "fr" ? "fr" : "en"}-CA`
  );

  return (
    <Modal
      title={t("purchase:cancel_appointment")}
      alignment="center"
      isOpen
      onClose={() => {
        onClose?.();
      }}
      contentHeading={t(
        "purchase:are_you_sure_you_want_to_cancel_your_appoitment"
      )}
    >
      <p className="text-black mt-2 mb-6">
        <Trans
          t={t}
          i18nKey="purchase:the_appointment_will_be_cancelled"
          values={{
            appointmentDate: formattedAppointmentDate,
            appointmentTime: formattedAppointmentTime,
            locationName: dropOffLocationName,
          }}
          components={{
            b: <span className="font-semibold" />,
          }}
        />
      </p>
      <div className="flex flex-col gap-1 items-center">
        <Button onClick={handleOnSubmit}>{t("common:confirm")}</Button>
        <Button fill="link" onClick={() => onClose?.()}>
          {t("common:cancel")}
        </Button>
      </div>
    </Modal>
  );
};

export default CancelDropOffAppointmentModal;
